import React from 'react';
import './SpecificationSection.css';

const TechnicalSpecification = () => {
  const specifications = [
    { title: 'Product', description: 'HST-Wall' },
    { title: 'Product Code', description: 'CHA21' },
    { title: 'Product Generic Name', description: 'Autonomous Hand Sanitizer' },
    { title: 'Product Colour', description: 'White & Black' },
    { title: 'Mounting', description: 'Wall-Mounting' },
    { title: 'Electrical Input', description: '230 V AC' },
    { title: 'Battery', description: '15 V (5000mAh)' },
    { title: 'Capacity of Sanitizer', description: 'One Litre' },
    { title: 'Dispensing Qty.', description: '1-1.5ml' },
    { title: 'Working Voltage', description: '24 V DC-1.5A' },
    { title: 'Auto Sensing Distance', description: '200mm to 250mm' },
    { title: 'Sensing Time', description: '0.2 seconds typical between sensing 3 seconds gap is required' },
    { title: 'Sensing Type', description: 'Infrared Sensor' },
    { title: 'Hands to be used (Single or Multi)', description: 'Will work with both options' },
    { title: 'Net Weight', description: '2.7Kg Approx.' },
    { title: 'Dimensions (mm)', description: '91(L) X 151(W) X 292(H)(in mm)' },
    { title: 'Total Power Consumption', description: '40W' },
  ];

  return (
    <div className="specification-section">
      <h2 className="specification-main">UNTOUCHED</h2>
      <h2 className="specification-heading">Technical Specification</h2>
      <div className='specification-container'>
      {specifications.map((specification, index) => (
        <React.Fragment key={index}>
          <div className="specification-item">
            <div className="specification-title">{specification.title}</div>
            <div className="specification-description">{specification.description}</div>
          </div>
          {index !== specifications.length - 1 && <div className="specification-divider"></div>}
        </React.Fragment>
      ))}
      </div>
    </div>
  );
};

export default TechnicalSpecification;
